import Scroll from "react-scroll";
import styled from "styled-components";
const ScrollLink = Scroll.Link;

const StyledWrapper = styled.div`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  padding: 2rem 0;
  justify-content: center;
  background: var(--raised-background-color);
  @media screen and (max-width: 992px) {
    flex-direction: column;
    display: none;
  }
`;
const StyledContainer = styled.div`
  width: 100%;
  max-width: 1280px;
  @media screen and (max-width: 1280px) {
    padding: 0 1rem;
  }
  h2 {
    font-size: 1.6rem;
    line-height: 2rem;
  }
`;
const StyledContainerInner = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: 992px) {
    width: 75%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  a {
    border: 1px solid #666;
    color: var(--text-color);
    border-radius: 5px;
    transition: 0.2s ease;
    padding: 0.5rem;
    margin: 3px;
    cursor: pointer;
    &:hover {
      text-decoration: none;
      border: 1px solid #6c91f5;
      background-color: var(--raised-background-color);
    }
  }
  > a.active {
    border: 1px solid #6c91f5;
    background-color: var(--raised-background-color);
  }
`;

const Details = ({ singleData }) => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledContainerInner>
          {singleData.details?.map((value) => {
            return (
              <ScrollLink
                activeClass="active"
                spy={true}
                offset={-140}
                to={value.uniqueKey}
                key={value.uniqueKey}
              >
                {value.title}
              </ScrollLink>
            );
          })}
        </StyledContainerInner>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Details;
